import React, { useState, useEffect, useRef } from "react";
import Toggler from "sulu-admin-bundle/components/Toggler/Toggler.js";
import { changeSecondsToString } from "../../../hooks/useCountdown";
import CardDetails from "../CardDetails";
import GoalDetails from "../GoalDetails";
import PSPCDetails from "../PSPCDetails";
import overrides from "../../../../css/customization.scss";
import styles from "./match-item-display.module.scss";
import Submit from "../HandleSubmit";
import EndGameIcon from "../../../../svgs/EndGame";
import CommentDetails from "../CommentDetails";
import Loader from "sulu-admin-bundle/components/Loader";
const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn(...args);
        }, delay);
    };
};

let checkForChange = (
    events,
    matchId,
    matchData,
    setMatchData,
    setEventsToShow
) => {
    const check = events.some((ev) => {
        return ev.isChanged;
    });

    if (!check) {
        return;
    }

    const filteredId = events.filter((ev) => ev.isChanged).map((ev) => ev.id);
    const update = {
        matchPosts: matchData.matchPosts.map((post) => {
            if (filteredId.includes(post.id)) {
                return {
                    ...post,
                    isLive: !post.isLive,
                    isChanged: true,
                };
            }
            return post;
        }),
    };

    Submit(matchId, matchData, update, setMatchData)
        .then((res) => {
            if (!res) {
                return;
            }
            setEventsToShow((data) => [
                ...data?.map((item) => {
                    if (filteredId.includes(item.id)) {
                        return {
                            ...item,
                            isChanged: false,
                        };
                    }
                    return item;
                }),
            ]);
        })
        .catch((e) => console.log(e.message));
};

checkForChange = debounce(checkForChange, 2000);

const MatchItemDisplay = ({
    evt,
    setIsEditModalOpen,
    setEventDetailsToEdit,
    setEventsToShow,
    setIsEditing,
    setComponentToInsertInModal,
    eventsToShow,
    matchData,
    matchId,
    setMatchData,
    periodAbbr,
}) => {
    const isFirstRun = useRef(true);
    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        checkForChange(
            eventsToShow,
            matchId,
            matchData,
            setMatchData,
            setEventsToShow
        );
    }, [eventsToShow]);

    if (evt.isCompleted || evt.isShootout) {
        const { type: { editComponentToOpen } = "" } = evt;
        const onClick = () => {
            if (editComponentToOpen) {
                setComponentToInsertInModal(editComponentToOpen);
                setEventDetailsToEdit(evt);
                setIsEditing(true);
                setIsEditModalOpen(true);
            }

            return () => {};
        };
        //event for completed match
        return (
            <div
                style={{
                    backgroundColor: "white",
                    width: "100%",
                    alignItems: "center",
                    padding: 5,
                    borderLeft: `12px solid #FF0014`,
                    margin: "5px 0",
                    borderRadius: 3,
                    gridTemplateColumns: "1fr 2fr 3fr 2fr 85px",
                    cursor: "pointer",
                    ...(!editComponentToOpen ? { cursor: "auto" } : {}),
                }}
                className={styles.matchEvent}
                onClick={onClick}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "7px",
                    }}
                >
                    <p className={overrides["roboto-16-700"]}>
                        {changeSecondsToString("timeOfEvent", evt?.timestamp)}
                    </p>
                    <p
                        className={overrides["roboto-16-500"]}
                        style={{
                            color: "gray",
                            width: "20px",
                        }}
                    >
                        {evt.quarter}
                    </p>
                </div>
                <div
                    style={{
                        width: "10%",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <EndGameIcon />
                    <p
                        className={overrides["roboto-16-700"]}
                        style={{
                            marginLeft: "9px",
                            letterSpacing: "2px",
                        }}
                    >
                        {evt.homeGoals}:{evt.awayGoals}
                    </p>
                </div>
                <p>{evt.comment}</p>
            </div>
        );
    } else {
        //all other events
        const {
            quarterSelected,
            sideSelected,
            type: { editComponentToOpen },
        } = evt;
        const currentActiveQuarter = quarterSelected.match(/\d+/)
            ? periodAbbr + quarterSelected.substr(quarterSelected.length - 1)
            : quarterSelected;
        const onClick = () => {
            if (editComponentToOpen) {
                setComponentToInsertInModal(editComponentToOpen);
                setEventDetailsToEdit(evt);
                setIsEditing(true);
                setIsEditModalOpen(true);
            }

            return () => {};
        };

        return (
            <div
                style={{
                    backgroundColor: "white",
                    width: "100%",
                    alignItems: "center",
                    padding: 5,
                    borderLeft: !sideSelected
                        ? `12px solid #595959`
                        : `12px solid ${sideSelected?.teamColor}`,
                    margin: "5px 0",
                    borderRadius: 3,
                    cursor: "pointer",
                    ...(!editComponentToOpen ? { cursor: "auto" } : {}),
                }}
                className={`${overrides["roboto-16-500"]} ${styles.matchEvent}`}
                onClick={evt.loaded && onClick}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "7px",
                    }}
                >
                    <p className={overrides["roboto-16-700"]}>
                        {changeSecondsToString("timeOfEvent", evt?.timestamp)}
                    </p>
                    <p
                        style={{
                            color: "gray",
                            width: "20px",
                        }}
                    >
                        {currentActiveQuarter}
                    </p>
                </div>

                {evt?.type?.name === "PS" && (
                    <PSPCDetails eventDetails={evt} text="PS" />
                )}
                {evt?.type?.name === "PC" && (
                    <PSPCDetails eventDetails={evt} text="PC" />
                )}
                {evt?.type?.name === "GOAL" && (
                    <GoalDetails eventDetails={evt} />
                )}
                {evt?.type?.name === "COMMENT" && (
                    <CommentDetails eventDetails={evt} />
                )}
                {["GRÜN", "GELB", "ROT", "GELB ROT"].includes(
                    evt?.type?.name
                ) && (
                    <CardDetails
                        eventDetails={evt}
                        background={evt?.type?.background}
                    />
                )}

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <span
                        className={overrides["roboto-16-700"]}
                        style={{
                            marginRight: 10,
                        }}
                    >
                        Live
                    </span>
                    {evt.loaded ? (
                        <Toggler
                            checked={evt?.liveEvent}
                            onChange={() => {
                                const originalEvent = matchData.matchPosts.find(
                                    (post) => post.id === evt.id
                                );
                                if (originalEvent.isLive === null) {
                                    originalEvent.isLive = true;
                                }
                                setEventsToShow((data) => [
                                    ...data?.map((item) => {
                                        if (item?.id === evt?.id) {
                                            return {
                                                ...item,
                                                liveEvent: !item?.liveEvent,
                                                isChanged:
                                                    originalEvent.isLive !==
                                                    !item.liveEvent,
                                            };
                                        }

                                        return item;
                                    }),
                                ]);
                            }}
                        />
                    ) : (
                        <Loader size={24} />
                    )}
                </div>
            </div>
        );
    }
};

export default MatchItemDisplay;
